import { useEffect, useState } from "react";
import { authFetch } from "./authFetch";
export default function useOrderTypes() {
  const [types, setTypes] = useState([{ id: 2, label: "Clienți" }, { id: 1, label: "Intern" }]);
  useEffect(() => {
    let active = true;
    authFetch("/comenzi/tipuri").then((items) => { if (active && items.length) setTypes(items); }).catch(() => {});
    return () => { active = false; };
  }, []);
  return types;
}
